/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Agent_Schedule_Summary_MonthlyInputs */



/**
* | output |
* | --- |
* | "On day {day} of every month at {time}" |
*
* @param {Agent_Schedule_Summary_MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_monthly = /** @type {((inputs: Agent_Schedule_Summary_MonthlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_MonthlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Am ${i?.day}. jedes Monats um ${i?.time}`)
	return /** @type {LocalizedString} */ (`On day ${i?.day} of every month at ${i?.time}`)
});